import React, { useState, useEffect } from "react";
import { CiBookmark } from "react-icons/ci";
import { MdOutlineSignalCellularAlt } from "react-icons/md";
import Utils from "../../utils/utils";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

const ProjectCard = ({ props }) => {
  const { item, index, onView } = props;
  const { Projects } = useAppLibs();
  const LEVEL = Projects.LEVEL;
  const SUBJECT = Projects.SUBJECT;
  var difficulty = LEVEL[item.level];

  return (
    <div
      bkl={"ProjectCard" + item._id}
      key={`ProjectCard-${item._id}-${index * index}`}
      className="group relative mb-4 overflow-hidden rounded-xl border bg-white p-6 transition-all hover:shadow-lg flex flex-wrap md:flex-nowrap xs:flex-none"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        className="
        absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-pink-600 to-pink-800"
      />

      <div
        bkl="ProjectDetailsCard"
        key={"ProjectCardView" + index}
        className="w-full md:w-1/2 xs:w-full space-y-2"
      >
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div className="order-2 flex-1 space-y-4 sm:order-1 ">
            <div>
              <h3 className="font-semibold text-gray-900">{item.title}</h3>
              {item.description && (
                <p className="mt-1 text-sm text-gray-600">{item.description}</p>
              )}
              {item.instruction && (
                <p className="mt-2 text-sm italic text-gray-500">
                  {item.instruction}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 text-sm text-gray-600">
          <CiBookmark size={16} />
          <span className="color">{SUBJECT[item?.subject]}</span>
        </div>

        <div className="flex items-center gap-2 text-sm text-gray-600">
          <MdOutlineSignalCellularAlt size={16} />
          <button
            disabled
            className={` px-2 py-1 shadow ${difficulty.text} ${difficulty.bg} rounded`}
          >
            {difficulty.name}
          </button>
        </div>

        <span className="text-xs text-gray-600 mt-1 -mb-3  italic flex">
          {Utils.formatDateTime(item.createdAt)}
        </span>
      </div>

      <div
        bkl="ProjectDocsCard"
        className="flex-1 p-4 w-full md:w-1/2 border-t md:border-t-0 shadow-inner flex flex-col justify-between rounded
        transition-all duration-300 "
      >
        <div>
          {item?.docs.map((doc, i) => (
            <button
              className="text-blue-500"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.open(doc.url, "_blank", "noopener,noreferrer");
              }}
            >
              {doc.name}
            </button>
          ))}
        </div>
        <div className=" text-right">
          <button
            className="text-sm px-4 py-2 uppercase border border-pink-700 text-pink-800 rounded-md
              hover:text-pink-900 hover:tracking-[0.05rem] hover:text-semibold  transition-all duration-200"
            onClick={() => onView(item, index)}
          >
            View Project
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
